import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Button from "../../components/button";
import PageTitle from "../../components/pageTitle";
import { StoreState } from "../../redux/reduxTypes";
import { ExtratoRepasseState, UserSession } from "../../types/state.types";
import {
  formatData,
  formatCompetence,
  formatMoney,
} from "../../utils/functions-helper";
import {
  AreaCooperado,
  AreaData,
  AreaInfo,
  ContainerPagina,
  Demonstrativo,
  LinhasTabela,
  LinhasTabelaDetalhamentos,
  LinhasTabelaProcedimentos,
  LinhasTabelaProducoes,
  LinhasTabelaProdutividade,
  LinhasTabelaResumo,
  ProducaoRepasseTabela,
  TabelaConteudo,
} from "./styled";

import { getSessionConfig } from "../../utils/session-helper";
import { ExtratoRepasseType } from "../../types/extratoRepasse.types";
import IndicadorSemDados from "../../components/indicadorSemDados";
import {
  AreaCooperadoSintetico,
  AreaDataSintetico,
  AreaInfoSintetico,
  DiscriminacaoVerbaSintetico,
  InfoCooperativaSintetico,
  TabelaConteudoSintetico,
  ColunasDescricaoSintetico,
  ColunasImpostosSintetico,
  ColunasLiquidoSintetico,
  ColunasTotalSintetico,
  LinhasTabelaSintetico,
} from "./styledSintetico";
import { useNavigate } from "react-router-dom";
import routes from "../../routes/routes.path";

function ExtratoRepasseImpressao() {
  const {
    filtros,
    dadosProcedimentos,
    dadosRelatorioProdutividade,
    dadosPlantoesNormais,
    dadosPlantoesSobreaviso,
    dadosPlantoesNormaisResumo,
    dadosPlantoesSobreavisoResumo,
    dadosProducoesNormais,
    dadosProducoesSobreaviso,
    dadosTotalProducoesNormais,
    dadosTotalProducoesSobreaviso,
    dadosExtrato,
    dadosExtratoSintetico,
    dadosDetalhamentosExtra,
  } = useSelector<StoreState, ExtratoRepasseState>(
    (state) => state.extratoRepasseState
  );
  const userData = useSelector<StoreState, UserSession | undefined>(
    (state) => state.loginState.userData
  );
  const [dadosExtratoProducao, setDadosExtratoProducao] = useState<
    ExtratoRepasseType[]
  >([]);
  const [dadosExtratoRepasse, setDadosExtratoRepasse] = useState<
    ExtratoRepasseType[]
  >([]);
  const [cooperativaSessionData] = useState(getSessionConfig());
  const navigate = useNavigate();

  useEffect(() => {
    if (dadosExtrato) {
      setDadosExtratoProducao(
        dadosExtrato.filter((verba) => verba.ID_TipoInfo === 1)
      );
      setDadosExtratoRepasse(
        dadosExtrato.filter((verba) => verba.ID_TipoInfo === 2)
      );
    }
  }, [dadosExtrato]);

  const irParaRelatorio = useCallback(() => {
    navigate(routes.ExtratoRepasse);
  }, [navigate]);

  const imprimirPagina = useCallback(
    () => {
      window.print();
      // irParaRelatorio();
    },
    [
      /* irParaRelatorio */
    ]
  );

  return (
    <ContainerPagina>
      <PageTitle titulo="Extrato de Repasse" />

      <section className="btnGroup">
        <Button primary onClick={imprimirPagina}>
          Imprimir
        </Button>
        <Button primary onClick={irParaRelatorio}>
          Voltar
        </Button>
      </section>

      <div className="tabela">
        {filtros.sintetico ? (
          dadosExtratoSintetico && dadosExtratoSintetico.Verbas.length > 0 ? (
            <TabelaConteudoSintetico id="conteudoParaPdf">
              <tbody>
                <tr>
                  <td>
                    <header>
                      <AreaDataSintetico>
                        <tbody>
                          <tr>
                            <td>
                              {new Date().toLocaleDateString("pt-Br", {
                                weekday: "long",
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              })}
                            </td>
                          </tr>
                        </tbody>
                      </AreaDataSintetico>

                      <AreaInfoSintetico>
                        <tbody>
                          <tr>
                            <td>
                              <img
                                src={
                                  "data:image/png;base64, " +
                                  cooperativaSessionData.Logo
                                }
                                alt={`Logotipo - ${
                                  cooperativaSessionData.Nome?.split(" ")[0]
                                }`}
                              />
                            </td>
                            <td className="containerInfos">
                              <span>
                                <strong>EXTRATO DE REPASSE</strong>
                                <br />
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </AreaInfoSintetico>

                      <InfoCooperativaSintetico>
                        <tbody>
                          <tr>
                            <td>
                              COOPERATIVA
                              <strong>{cooperativaSessionData.Nome}</strong>
                            </td>

                            <td>
                              CNPJ
                              <strong>{cooperativaSessionData.CNPJ}</strong>
                            </td>

                            <td>
                              ADMISSÃO
                              <strong>
                                {dadosExtratoSintetico.DataAdmissao
                                  ? formatData(
                                      dadosExtratoSintetico.DataAdmissao
                                    )
                                  : " -- "}
                              </strong>
                            </td>

                            <td>
                              COMPETÊNCIA
                              <strong>
                                {dadosExtratoSintetico.Competencia}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </InfoCooperativaSintetico>

                      <AreaCooperadoSintetico>
                        <tbody>
                          <tr>
                            <td>
                              COOPERADO
                              <strong>
                                {userData
                                  ? `${userData.Matricula} - ${userData.Nome}`
                                  : " -- "}
                              </strong>
                            </td>

                            <td>
                              CARGO
                              <strong>
                                {dadosExtratoSintetico.Cargo ?? " -- "}
                              </strong>
                            </td>

                            <td>
                              LOTAÇÃO
                              <strong>{dadosExtratoSintetico.Lotacao}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </AreaCooperadoSintetico>

                      <DiscriminacaoVerbaSintetico>
                        Discriminacao Das Verbas
                      </DiscriminacaoVerbaSintetico>
                    </header>

                    <ColunasDescricaoSintetico>
                      <tbody>
                        <tr>
                          <td>COD.</td>
                          <td>DESCRIÇÃO</td>
                          <td>REFERÊNCIA</td>
                          <td>PROVENTO</td>
                          <td>DESCONTO</td>
                        </tr>
                      </tbody>
                    </ColunasDescricaoSintetico>
                    <main>
                      <LinhasTabelaSintetico>
                        <tbody>
                          {dadosExtratoSintetico ? (
                            dadosExtratoSintetico.Verbas.map((extrato, i) => {
                              return (
                                <tr key={i}>
                                  <td>{extrato.VerbaID}</td>

                                  <td
                                    style={{
                                      textAlign: "left",
                                      paddingLeft: "8px",
                                    }}
                                  >
                                    {extrato.Descricao}
                                  </td>

                                  <td>{extrato.Referencia}</td>

                                  <td>
                                    {extrato.ValorProvento > 0
                                      ? formatMoney(extrato.ValorProvento)
                                      : ""}
                                  </td>

                                  <td>
                                    {extrato.ValorDesconto > 0
                                      ? formatMoney(extrato.ValorDesconto)
                                      : ""}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <></>
                          )}
                          {[10, 11, 12, 13, 14].map((i) => (
                            <tr key={i}>
                              <td></td>

                              <td></td>

                              <td></td>

                              <td></td>

                              <td></td>
                            </tr>
                          ))}
                        </tbody>
                      </LinhasTabelaSintetico>

                      <ColunasTotalSintetico>
                        <tbody>
                          <tr>
                            <td> </td>
                            <td>
                              TOTAL PROVENTOS
                              <strong>
                                {formatMoney(
                                  dadosExtratoSintetico.TotalProventos
                                )}
                              </strong>
                            </td>
                            <td>
                              TOTAL DESCONTOS
                              <strong>
                                {formatMoney(
                                  dadosExtratoSintetico.TotalDescontos
                                )}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </ColunasTotalSintetico>

                      <ColunasLiquidoSintetico>
                        <tbody>
                          <tr>
                            <td> </td>
                            <td id="valorLiquido">
                              LÍQUIDO A RECEBER
                              <strong>
                                {formatMoney(
                                  dadosExtratoSintetico.ValorLiquido
                                )}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </ColunasLiquidoSintetico>

                      <ColunasImpostosSintetico>
                        <tbody>
                          <tr>
                            <td> </td>
                            <td>
                              BASE DE CALCULO DO INSS
                              <strong>
                                {formatMoney(dadosExtratoSintetico.BaseINSS)}
                              </strong>
                            </td>
                            <td>
                              BASE DE CALCULO DO IRRF
                              <strong>
                                {formatMoney(dadosExtratoSintetico.BaseIRRF)}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </ColunasImpostosSintetico>
                    </main>
                  </td>
                </tr>
              </tbody>
            </TabelaConteudoSintetico>
          ) : (
            <IndicadorSemDados />
          )
        ) : dadosExtrato && dadosExtrato.length > 0 ? (
          <TabelaConteudo id="conteudoParaPdf">
            <tbody>
              <tr>
                <td id="principal">
                  <header>
                    <AreaData>
                      <tbody>
                        <tr>
                          <td>
                            {new Date().toLocaleDateString("pt-Br", {
                              weekday: "long",
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })}
                          </td>
                        </tr>
                      </tbody>
                    </AreaData>

                    <AreaInfo>
                      <tbody>
                        <tr>
                          <td>
                            <img
                              src={
                                "data:image/png;base64, " +
                                cooperativaSessionData.Logo
                              }
                              alt={`Logotipo - ${
                                cooperativaSessionData.Nome?.split(" ")[0]
                              }`}
                            />
                          </td>
                          <td className="containerInfos">
                            <span>
                              <strong>EXTRATO DE REPASSE</strong>
                              <br />
                            </span>
                            <span>
                              COMPETÊNCIA: &nbsp;
                              <strong>
                                {formatCompetence(dadosExtrato[0].Competencia)}
                              </strong>
                            </span>
                            <span>
                              LOTAÇÃO: &nbsp;
                              <strong>{dadosExtrato[0].NomeContrato}</strong>
                            </span>
                          </td>
                        </tr>
                        <tr className="dadosCooperativa">
                          <td>{cooperativaSessionData.Nome}</td>
                          <td>CNPJ: {cooperativaSessionData.CNPJ}</td>
                        </tr>
                      </tbody>
                    </AreaInfo>

                    <AreaCooperado>
                      <tbody>
                        <tr>
                          <td>
                            <strong>Cooperado:</strong>{" "}
                            {userData ? userData.Nome : ""}
                          </td>
                          <td>
                            <strong>Matricula:</strong>{" "}
                            {userData ? userData.Matricula : ""}
                          </td>
                          <td>
                            <strong>Data de Pagamento:</strong>{" "}
                            {formatData(dadosExtrato[0].DatPagamento)}
                          </td>
                          {/* <td><strong>Categoria:</strong> {
                    dadosPlantoesNormais ? dadosPlantoesNormais[0].Categoria : ''}</td> */}
                        </tr>
                      </tbody>
                    </AreaCooperado>

                    <Demonstrativo>Demonstrativo</Demonstrativo>
                  </header>

                  {dadosExtratoProducao.length > 0 ? (
                    <ProducaoRepasseTabela>
                      <tbody>
                        <tr className="cabecalhoTabelaSecao">
                          <td>PRODUÇÃO</td>
                        </tr>
                        {dadosExtratoProducao.map((verba) => {
                          return (
                            <tr key={verba.Verba}>
                              <td className={verba.Negrito ? "destaque" : ""}>
                                {verba.Verba}
                              </td>
                              <td className={verba.Negrito ? "destaque" : ""}>
                                {formatMoney(verba.ValorVerba)} {verba.Operacao}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </ProducaoRepasseTabela>
                  ) : (
                    <></>
                  )}

                  {dadosExtratoRepasse.length > 0 ? (
                    <ProducaoRepasseTabela>
                      <tbody>
                        <tr className="cabecalhoTabelaSecao">
                          <td>REPASSE</td>
                        </tr>
                        {dadosExtratoRepasse.map((verba) => {
                          if (
                            verba.Verba === "Valor Bruto" ||
                            verba.Verba === "Valor Líquido"
                          ) {
                            return (
                              <tr key={verba.Verba}>
                                <td>
                                  <strong>{verba.Verba}</strong>
                                </td>
                                <td>
                                  <strong>
                                    {formatMoney(verba.ValorVerba)}{" "}
                                    {verba.Operacao}
                                  </strong>
                                </td>
                              </tr>
                            );
                          }
                          return (
                            <tr key={verba.Verba}>
                              <td>{verba.Verba}</td>
                              <td>
                                {formatMoney(verba.ValorVerba)} {verba.Operacao}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </ProducaoRepasseTabela>
                  ) : (
                    <></>
                  )}

                  <main>
                    {dadosRelatorioProdutividade &&
                    dadosRelatorioProdutividade.length > 0 ? (
                      <LinhasTabelaProdutividade>
                        <tbody>
                          <tr className="cabecalhoTabela">
                            <td>PRODUTIVIDADE</td>
                          </tr>

                          <tr className="colunasDescricao">
                            <td>Competência</td>
                            <td>Função</td>
                            <td>Verba</td>
                            <td>Carga Horária</td>
                            <td>Valor</td>
                          </tr>
                          {dadosRelatorioProdutividade.map((extrato, i) => {
                            return (
                              <tr key={i}>
                                <td>{extrato.Competencia}</td>
                                <td>{extrato.Funcao}</td>
                                <td>{extrato.Verba}</td>
                                <td>{extrato.CargaHoraria}</td>
                                <td>
                                  {formatMoney(extrato.ValorProdutividade)}
                                </td>
                              </tr>
                            );
                          })}
                          <tr className="colunasTotal">
                            <td>Total</td>
                            <td>
                              {dadosRelatorioProdutividade.reduce(
                                (anterior, produtividade) => {
                                  return anterior + produtividade.CargaHoraria;
                                },
                                0
                              )}
                            </td>
                            <td>
                              {formatMoney(
                                dadosRelatorioProdutividade.reduce(
                                  (anterior, produtividade) => {
                                    return (
                                      anterior +
                                      produtividade.ValorProdutividade
                                    );
                                  },
                                  0
                                ) ?? 0
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </LinhasTabelaProdutividade>
                    ) : (
                      <></>
                    )}

                    {dadosProcedimentos && dadosProcedimentos.length > 0 ? (
                      <LinhasTabelaProcedimentos>
                        <tbody>
                          <tr className="cabecalhoTabela">
                            <td>PROCEDIMENTOS</td>
                          </tr>

                          <tr className="colunasDescricao">
                            <td>Competência</td>
                            <td>Setor</td>
                            <td>Procedimento</td>
                            <td>Grau Participação</td>
                            <td>Qtde</td>
                            <td>Valor Unit.</td>
                            <td>Valor Total</td>
                          </tr>
                          {dadosProcedimentos.map((extrato, i) => {
                            return (
                              <tr key={i}>
                                <td>{extrato.Competencia}</td>
                                <td>{extrato.Setor}</td>
                                <td>{extrato.Procedimento}</td>
                                <td>{extrato.GrauParticipacao}</td>
                                <td>{extrato.Quantidade}</td>
                                <td>{formatMoney(extrato.ValorUnitario)}</td>
                                <td>
                                  {formatMoney(extrato.ValorProcedimento)}
                                </td>
                              </tr>
                            );
                          })}
                          <tr className="colunasTotal">
                            <td>Total</td>
                            <td>
                              {dadosProcedimentos.reduce(
                                (anterior, produtividade) => {
                                  return anterior + produtividade.Quantidade;
                                },
                                0
                              )}
                            </td>
                            <td> </td>
                            <td>
                              {formatMoney(
                                dadosProcedimentos.reduce(
                                  (anterior, produtividade) => {
                                    return (
                                      anterior + produtividade.ValorUnitario
                                    );
                                  },
                                  0
                                ) ?? 0
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </LinhasTabelaProcedimentos>
                    ) : (
                      <></>
                    )}

                    {dadosPlantoesNormais && dadosPlantoesNormais.length > 0 ? (
                      <LinhasTabela>
                        <tbody>
                          <tr className="cabecalhoTabela">
                            <td>PLANTÕES NORMAIS</td>
                          </tr>

                          <tr className="colunasDescricao">
                            <td>Data</td>
                            <td>Dia Semana</td>
                            <td>Função</td>
                            <td>Setor</td>
                            <td>Turno</td>
                            <td>Início</td>
                            <td>Fim</td>
                            <td>Horas</td>
                            <td>Valor</td>
                          </tr>
                          {dadosPlantoesNormais.map((extrato, i) => {
                            return (
                              <tr key={i}>
                                <td>{formatData(extrato.Data)}</td>
                                <td>{extrato.DiaSemana}</td>
                                <td>{extrato.Funcao}</td>
                                <td>{extrato.Setor}</td>
                                <td>{extrato.Turno}</td>
                                <td>{extrato.Data.substring(11, 16)}</td>
                                <td>{extrato.DataFim.substring(11, 16)}</td>
                                <td>{extrato.QtdeHorasList}</td>
                                <td>{formatMoney(extrato.ValorExtrato)}</td>
                              </tr>
                            );
                          })}
                          <tr className="colunasTotal">
                            <td>Quantidade: {dadosPlantoesNormais.length}</td>
                            <td>Total</td>
                            <td>
                              {formatMoney(
                                dadosPlantoesNormais.reduce(
                                  (anterior, plantao) => {
                                    return anterior + plantao.ValorExtrato;
                                  },
                                  0
                                ) ?? 0
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </LinhasTabela>
                    ) : (
                      <></>
                    )}

                    {dadosPlantoesNormaisResumo &&
                    dadosPlantoesNormaisResumo.length > 0 ? (
                      <LinhasTabelaResumo>
                        <tbody>
                          <tr className="cabecalhoTabela">
                            <td>RESUMO DE PLANTÕES NORMAIS POR TURNO</td>
                          </tr>

                          <tr className="colunasDescricaoResumo">
                            <td>Diurno</td>
                            <td>Noturno</td>
                            <td>Diurno FDS</td>
                            <td>Noturno FDS</td>
                            <td></td>
                          </tr>
                          <tr className="colunasDescricao">
                            <td>Horas</td>
                            <td>Valor</td>
                            <td>Horas</td>
                            <td>Valor</td>
                            <td>Horas</td>
                            <td>Valor</td>
                            <td>Horas</td>
                            <td>Valor</td>
                            <td>Total Horas</td>
                            <td>Valor Total</td>
                          </tr>
                          {dadosPlantoesNormaisResumo.map((extrato, i) => {
                            return (
                              <tr key={i + ".2"}>
                                <td>{extrato.QtdeHorasDiurno}</td>
                                <td>
                                  {formatMoney(
                                    extrato.ValorExtratoDiurno,
                                    true
                                  )}
                                </td>
                                <td>{extrato.QtdeHorasNoturno}</td>
                                <td>
                                  {formatMoney(
                                    extrato.ValorExtratoNoturno,
                                    true
                                  )}
                                </td>
                                <td>{extrato.QtdeHorasDiurnoFDS}</td>
                                <td>
                                  {formatMoney(
                                    extrato.ValorExtratoDiurnoFDS,
                                    true
                                  )}
                                </td>
                                <td>{extrato.QtdeHorasNoturnoFDS}</td>
                                <td>
                                  {formatMoney(
                                    extrato.ValorExtratoNoturnoFDS,
                                    true
                                  )}
                                </td>
                                <td>{extrato.QtdeTotalHoras}</td>
                                <td>{formatMoney(extrato.ValorTotal, true)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </LinhasTabelaResumo>
                    ) : (
                      <></>
                    )}

                    {dadosPlantoesSobreaviso &&
                    dadosPlantoesSobreaviso.length > 0 ? (
                      <LinhasTabela>
                        <tbody>
                          <tr className="cabecalhoTabela">
                            <td>PLANTÕES SOBREAVISO</td>
                          </tr>

                          <tr className="colunasDescricao">
                            <td>Data</td>
                            <td>Dia Semana</td>
                            <td>Setor</td>
                            <td>Turno</td>
                            <td>Início</td>
                            <td>Fim</td>
                            <td>Horas</td>
                            <td>Valor</td>
                          </tr>
                          {dadosPlantoesSobreaviso.map((plantao, i) => {
                            return (
                              <tr key={i}>
                                <td>{formatData(plantao.Data)}</td>
                                <td>{plantao.DiaSemana}</td>
                                <td>{plantao.Setor}</td>
                                <td>{plantao.Turno}</td>
                                <td>{plantao.Data.substring(11, 16)}</td>
                                <td>{plantao.DataFim.substring(11, 16)}</td>
                                <td>{plantao.QtdeHorasList}</td>
                                <td>{formatMoney(plantao.ValorExtrato)}</td>
                              </tr>
                            );
                          })}
                          <tr className="colunasTotal">
                            <td>
                              Quantidade: {dadosPlantoesSobreaviso.length}
                            </td>
                            <td>Total</td>
                            <td>
                              {formatMoney(
                                dadosPlantoesSobreaviso.reduce(
                                  (anterior, plantao) => {
                                    return anterior + plantao.ValorExtrato;
                                  },
                                  0
                                ) ?? 0
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </LinhasTabela>
                    ) : (
                      <></>
                    )}

                    {dadosPlantoesSobreavisoResumo &&
                    dadosPlantoesSobreavisoResumo.length > 0 ? (
                      <LinhasTabelaResumo>
                        <tbody>
                          <tr className="cabecalhoTabela">
                            <td>RESUMO DE PLANTÕES SOBREAVISO POR TURNO</td>
                          </tr>

                          <tr className="colunasDescricaoResumo">
                            <td>Diurno</td>
                            <td>Noturno</td>
                            <td>Diurno FDS</td>
                            <td>Noturno FDS</td>
                            <td></td>
                          </tr>
                          <tr className="colunasDescricao">
                            <td>Horas</td>
                            <td>Valor</td>
                            <td>Horas</td>
                            <td>Valor</td>
                            <td>Horas</td>
                            <td>Valor</td>
                            <td>Horas</td>
                            <td>Valor</td>
                            <td>Total Horas</td>
                            <td>Valor Total</td>
                          </tr>
                          {dadosPlantoesSobreavisoResumo.map(
                            (resumoPlantao, i) => {
                              return (
                                <tr key={i + ".2"}>
                                  <td>{resumoPlantao.QtdeHorasDiurno}</td>
                                  <td>
                                    {formatMoney(
                                      resumoPlantao.ValorExtratoDiurno
                                    )}
                                  </td>
                                  <td>{resumoPlantao.QtdeHorasNoturno}</td>
                                  <td>
                                    {formatMoney(
                                      resumoPlantao.ValorExtratoNoturno
                                    )}
                                  </td>
                                  <td>{resumoPlantao.QtdeHorasDiurnoFDS}</td>
                                  <td>
                                    {formatMoney(
                                      resumoPlantao.ValorExtratoDiurnoFDS
                                    )}
                                  </td>
                                  <td>{resumoPlantao.QtdeHorasNoturnoFDS}</td>
                                  <td>
                                    {formatMoney(
                                      resumoPlantao.ValorExtratoNoturnoFDS
                                    )}
                                  </td>
                                  <td>{resumoPlantao.QtdeTotalHoras}</td>
                                  <td>
                                    {formatMoney(resumoPlantao.ValorTotal)}
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </LinhasTabelaResumo>
                    ) : (
                      <></>
                    )}

                    {(dadosProducoesNormais &&
                      dadosProducoesNormais.length > 0) ||
                    (dadosProducoesSobreaviso &&
                      dadosProducoesSobreaviso.length > 0) ? (
                      <LinhasTabelaProducoes>
                        <tbody>
                          <tr className="cabecalhoTabela">
                            <td>LANÇAMENTO DE CARGA HORÁRIA</td>
                          </tr>
                          {dadosProducoesNormais &&
                          dadosProducoesNormais.length > 0 ? (
                            <>
                              <tr className="cabecalhoTabela">
                                <td>PLANTÕES NORMAIS</td>
                              </tr>
                              <tr id="tabelaMista">
                                <td
                                  style={{
                                    margin: "0",
                                    padding: "0",
                                    border: "none",
                                  }}
                                >
                                  <table>
                                    <tbody>
                                      <tr className="colunasDescricao">
                                        <td width={"11%"} rowSpan={2}>
                                          Competência
                                        </td>
                                        <td width={"11%"} rowSpan={2}>
                                          Função
                                        </td>
                                        <td width={"10%"} rowSpan={2}>
                                          Setor
                                        </td>
                                        <td width={"15%"} colSpan={2}>
                                          Diurno
                                        </td>
                                        <td width={"15%"} colSpan={2}>
                                          Noturno
                                        </td>
                                        <td width={"15%"} colSpan={2}>
                                          Diurno FDS
                                        </td>
                                        <td width={"15%"} colSpan={2}>
                                          Noturno FDS
                                        </td>
                                        <td width={"8%"} rowSpan={2}>
                                          Valor Total
                                        </td>
                                      </tr>

                                      <tr className="colunasDescricao">
                                        <td className="hrValor" width={"6%"}>
                                          Horas
                                        </td>
                                        <td className="hrValor" width={"9%"}>
                                          Valor
                                        </td>
                                        <td className="hrValor" width={"6%"}>
                                          Horas
                                        </td>
                                        <td className="hrValor" width={"9%"}>
                                          Valor
                                        </td>
                                        <td className="hrValor" width={"6%"}>
                                          Horas
                                        </td>
                                        <td className="hrValor" width={"9%"}>
                                          Valor
                                        </td>
                                        <td className="hrValor" width={"6%"}>
                                          Horas
                                        </td>
                                        <td className="hrValor" width={"9%"}>
                                          Valor
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              {dadosProducoesNormais.map((producao) => (
                                <tr>
                                  <td>
                                    {formatCompetence(
                                      producao.Competencia,
                                      false
                                    )}
                                  </td>
                                  <td>{producao.Funcao}</td>
                                  <td>{producao.Setor}</td>
                                  <td>
                                    {producao.TurnoDiurno.HorasTrabalhadas}h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      producao.TurnoDiurno.ValorExtrato
                                    )}
                                  </td>

                                  <td>
                                    {producao.TurnoNoturno.HorasTrabalhadas}h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      producao.TurnoNoturno.ValorExtrato
                                    )}
                                  </td>

                                  <td>
                                    {producao.TurnoDiurnoFDS.HorasTrabalhadas}h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      producao.TurnoDiurnoFDS.ValorExtrato
                                    )}
                                  </td>

                                  <td>
                                    {producao.TurnoNoturnoFDS.HorasTrabalhadas}h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      producao.TurnoNoturnoFDS.ValorExtrato
                                    )}
                                  </td>

                                  <td>
                                    {formatMoney(
                                      producao.TurnoDiurno.ValorExtrato +
                                        producao.TurnoNoturno.ValorExtrato +
                                        producao.TurnoDiurnoFDS.ValorExtrato +
                                        producao.TurnoNoturnoFDS.ValorExtrato
                                    )}
                                  </td>
                                </tr>
                              ))}
                              {dadosTotalProducoesNormais ? (
                                <tr className="colunasTotal">
                                  <td>Total</td>
                                  <td>
                                    {
                                      dadosTotalProducoesNormais.TurnoDiurno
                                        .HorasTrabalhadas
                                    }
                                    h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      dadosTotalProducoesNormais.TurnoDiurno
                                        .Valor
                                    )}
                                  </td>
                                  <td>
                                    {
                                      dadosTotalProducoesNormais.TurnoNoturno
                                        .HorasTrabalhadas
                                    }
                                    h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      dadosTotalProducoesNormais.TurnoNoturno
                                        .Valor
                                    )}
                                  </td>
                                  <td>
                                    {
                                      dadosTotalProducoesNormais.TurnoDiurnoFDS
                                        .HorasTrabalhadas
                                    }
                                    h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      dadosTotalProducoesNormais.TurnoDiurnoFDS
                                        .Valor
                                    )}
                                  </td>
                                  <td>
                                    {
                                      dadosTotalProducoesNormais.TurnoNoturnoFDS
                                        .HorasTrabalhadas
                                    }
                                    h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      dadosTotalProducoesNormais.TurnoNoturnoFDS
                                        .Valor
                                    )}
                                  </td>
                                  <td>
                                    {formatMoney(
                                      dadosTotalProducoesNormais.TurnoDiurno
                                        .Valor +
                                        dadosTotalProducoesNormais.TurnoNoturno
                                          .Valor +
                                        dadosTotalProducoesNormais
                                          .TurnoDiurnoFDS.Valor +
                                        dadosTotalProducoesNormais
                                          .TurnoNoturnoFDS.Valor
                                    )}
                                  </td>
                                </tr>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                          {dadosProducoesSobreaviso &&
                          dadosProducoesSobreaviso.length > 0 ? (
                            <>
                              <tr className="cabecalhoTabela">
                                <td>PLANTÕES EM SOBREAVISO</td>
                              </tr>
                              <tr id="tabelaMista">
                                <td
                                  style={{
                                    margin: "0",
                                    padding: "0",
                                    border: "none",
                                  }}
                                >
                                  <table>
                                    <tbody>
                                      <tr className="colunasDescricao">
                                        <td width={"11%"} rowSpan={2}>
                                          Competência
                                        </td>
                                        <td width={"11%"} rowSpan={2}>
                                          Função
                                        </td>
                                        <td width={"10%"} rowSpan={2}>
                                          Setor
                                        </td>
                                        <td width={"15%"} colSpan={2}>
                                          Diurno
                                        </td>
                                        <td width={"15%"} colSpan={2}>
                                          Noturno
                                        </td>
                                        <td width={"15%"} colSpan={2}>
                                          Diurno FDS
                                        </td>
                                        <td width={"15%"} colSpan={2}>
                                          Noturno FDS
                                        </td>
                                        <td width={"8%"} rowSpan={2}>
                                          Valor Total
                                        </td>
                                      </tr>

                                      <tr className="colunasDescricao">
                                        <td className="hrValor" width={"6%"}>
                                          Horas
                                        </td>
                                        <td className="hrValor" width={"9%"}>
                                          Valor
                                        </td>
                                        <td className="hrValor" width={"6%"}>
                                          Horas
                                        </td>
                                        <td className="hrValor" width={"9%"}>
                                          Valor
                                        </td>
                                        <td className="hrValor" width={"6%"}>
                                          Horas
                                        </td>
                                        <td className="hrValor" width={"9%"}>
                                          Valor
                                        </td>
                                        <td className="hrValor" width={"6%"}>
                                          Horas
                                        </td>
                                        <td className="hrValor" width={"9%"}>
                                          Valor
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              {dadosProducoesSobreaviso.map((producao) => (
                                <tr>
                                  <td>
                                    {formatCompetence(
                                      producao.Competencia,
                                      false
                                    )}
                                  </td>
                                  <td>{producao.Funcao}</td>
                                  <td>{producao.Setor}</td>
                                  <td>
                                    {producao.TurnoDiurno.HorasTrabalhadas}h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      producao.TurnoDiurno.ValorExtrato
                                    )}
                                  </td>

                                  <td>
                                    {producao.TurnoNoturno.HorasTrabalhadas}h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      producao.TurnoNoturno.ValorExtrato
                                    )}
                                  </td>

                                  <td>
                                    {producao.TurnoDiurnoFDS.HorasTrabalhadas}h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      producao.TurnoDiurnoFDS.ValorExtrato
                                    )}
                                  </td>

                                  <td>
                                    {producao.TurnoNoturnoFDS.HorasTrabalhadas}h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      producao.TurnoNoturnoFDS.ValorExtrato
                                    )}
                                  </td>

                                  <td>
                                    {formatMoney(
                                      producao.TurnoDiurno.ValorExtrato +
                                        producao.TurnoNoturno.ValorExtrato +
                                        producao.TurnoDiurnoFDS.ValorExtrato +
                                        producao.TurnoNoturnoFDS.ValorExtrato
                                    )}
                                  </td>
                                </tr>
                              ))}
                              {dadosTotalProducoesSobreaviso ? (
                                <tr className="colunasTotal">
                                  <td>Total</td>
                                  <td>
                                    {
                                      dadosTotalProducoesSobreaviso.TurnoDiurno
                                        .HorasTrabalhadas
                                    }
                                    h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      dadosTotalProducoesSobreaviso.TurnoDiurno
                                        .Valor
                                    )}
                                  </td>
                                  <td>
                                    {
                                      dadosTotalProducoesSobreaviso.TurnoNoturno
                                        .HorasTrabalhadas
                                    }
                                    h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      dadosTotalProducoesSobreaviso.TurnoNoturno
                                        .Valor
                                    )}
                                  </td>
                                  <td>
                                    {
                                      dadosTotalProducoesSobreaviso
                                        .TurnoDiurnoFDS.HorasTrabalhadas
                                    }
                                    h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      dadosTotalProducoesSobreaviso
                                        .TurnoDiurnoFDS.Valor
                                    )}
                                  </td>
                                  <td>
                                    {
                                      dadosTotalProducoesSobreaviso
                                        .TurnoNoturnoFDS.HorasTrabalhadas
                                    }
                                    h
                                  </td>
                                  <td>
                                    {formatMoney(
                                      dadosTotalProducoesSobreaviso
                                        .TurnoNoturnoFDS.Valor
                                    )}
                                  </td>
                                  <td>
                                    {formatMoney(
                                      dadosTotalProducoesSobreaviso.TurnoDiurno
                                        .Valor +
                                        dadosTotalProducoesSobreaviso
                                          .TurnoNoturno.Valor +
                                        dadosTotalProducoesSobreaviso
                                          .TurnoDiurnoFDS.Valor +
                                        dadosTotalProducoesSobreaviso
                                          .TurnoNoturnoFDS.Valor
                                    )}
                                  </td>
                                </tr>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </tbody>
                      </LinhasTabelaProducoes>
                    ) : (
                      <></>
                    )}

                    {dadosDetalhamentosExtra &&
                    dadosDetalhamentosExtra.length > 0 ? (
                      <LinhasTabelaDetalhamentos>
                        <tbody>
                          <tr className="cabecalhoTabela">
                            <td>OUTROS LANÇAMENTOS</td>
                          </tr>

                          <tr className="colunasDescricao">
                            <td>Verba</td>
                            <td>Competência</td>
                            <td>Função</td>
                            <td>Setor</td>
                            <td>Data</td>
                            <td>Qtde</td>
                            <td>Valor Unitário</td>
                            <td>Valor Total</td>
                          </tr>
                          {dadosDetalhamentosExtra.map((detalhamento, i) => {
                            return (
                              <tr key={i}>
                                <td>{detalhamento.Titulo}</td>
                                <td>
                                  {formatCompetence(
                                    Number(detalhamento.Competencia),
                                    false
                                  )}
                                </td>
                                <td>{detalhamento.Funcao}</td>
                                <td>{detalhamento.Setor}</td>
                                <td>
                                  {detalhamento.DataProdutividade
                                    ? formatData(detalhamento.DataProdutividade)
                                    : "--"}
                                </td>
                                <td>{detalhamento.Quantidade}</td>
                                <td>
                                  {formatMoney(detalhamento.ValorUnitario)}
                                </td>
                                <td>{formatMoney(detalhamento.ValorTotal)}</td>
                              </tr>
                            );
                          })}
                          <tr className="colunasTotal">
                            <td>
                              Quantidade: {dadosDetalhamentosExtra.length}
                            </td>
                            <td>Total</td>
                            <td>
                              {formatMoney(
                                dadosDetalhamentosExtra.reduce(
                                  (anterior, plantao) => {
                                    return anterior + plantao.ValorTotal;
                                  },
                                  0
                                ) ?? 0
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </LinhasTabelaDetalhamentos>
                    ) : (
                      <></>
                    )}
                  </main>
                </td>
              </tr>
            </tbody>
          </TabelaConteudo>
        ) : (
          <IndicadorSemDados />
        )}
      </div>
    </ContainerPagina>
  );
}

export default ExtratoRepasseImpressao;
